'use strict';

/* Dependencies */
var React = require('react');

var _require = require('react-router');

var Route = _require.Route;
var DefaultRoute = _require.DefaultRoute;

/* Components */
var App = require('components/app');
var Login = require('components/login');
var Dashboard = require('components/dashboard');

var ProjectDetails = require('components/project/details');

module.exports = React.createElement(
  Route,
  { name: 'app', path: '/', handler: App },
  React.createElement(Route, { name: 'login', handler: Login }),
  React.createElement(Route, { name: 'new', path: '/:type/new', handler: Dashboard }),
  React.createElement(Route, { name: 'project', path: 'project/:projectId', handler: ProjectDetails }),
  React.createElement(Route, { name: 'details', path: '/:type/:id', handler: Dashboard }),
  React.createElement(DefaultRoute, { name: 'dashboard', handler: Dashboard })
);


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/routes/main.js
 **/